import { FilePlusIcon, SquaresFourIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";
import type { ReactNode } from "react";

type CoverLetterCreateCardProps = {
  onCreate: () => void;
  onUseTemplate: () => void;
  className?: string;
};

type CoverLetterActionProps = {
  label: string;
  description: string;
  icon: ReactNode;
  onClick: () => void;
};

const CoverLetterAction = ({ label, description, icon, onClick }: CoverLetterActionProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "group flex flex-1 items-center gap-4",
        "border-b border-slate-200 px-5 text-left",
        "text-indigo-950 transition-colors",
        "last:border-b-0 hover:bg-indigo-50/70",
        "focus-visible:relative focus-visible:outline-none",
        "focus-visible:ring-2 focus-visible:ring-inset",
        "focus-visible:ring-indigo-500",
      )}
    >
      <span
        className={cn(
          "grid size-12 shrink-0 place-items-center",
          "rounded-xl bg-indigo-50 text-indigo-600",
          "transition-colors group-hover:bg-indigo-100",
        )}
      >
        {icon}
      </span>

      <span className="min-w-0">
        <span className="block text-sm font-semibold">{label}</span>

        <span className="mt-1 block text-[11px] leading-4 text-slate-500">{description}</span>
      </span>
    </button>
  );
};

export const CoverLetterCreateCard = ({
  onCreate,
  onUseTemplate,
  className,
}: CoverLetterCreateCardProps) => {
  return (
    <article
      className={cn(
        "overflow-hidden rounded-2xl border",
        "border-dashed border-indigo-400 bg-white",
        "shadow-[0_8px_22px_rgba(15,23,42,0.04)]",
        className,
      )}
    >
      <div className="flex min-h-[370px] flex-col">
        <CoverLetterAction
          label="Nouvelle lettre"
          description="Commencer une nouvelle lettre de motivation"
          onClick={onCreate}
          icon={<FilePlusIcon aria-hidden size={26} weight="duotone" />}
        />

        <CoverLetterAction
          label="Utiliser un modèle"
          description="Choisir une mise en page professionnelle"
          onClick={onUseTemplate}
          icon={<SquaresFourIcon aria-hidden size={26} weight="duotone" />}
        />
      </div>
    </article>
  );
};
